<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Empresas</li>
        </ol>

        <div class="row">
          <div class="col-md-12 ">
            <div class="pull-right">
              <router-link to="empresas/cria-empresa"  class="btn_1 medium mb-3">Criar nova Empresa</router-link>
            </div>
          </div>
        </div>

        <v-card>
          <v-card-title>
            <h3>Empresas</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :no-data-text="textoTabela" :headers="headers" :items="empresas" :search="search" :pagination.sync="pagination">
            <template slot="items" slot-scope="props" v-if="!(props.item.deleted_at)">
              <td>{{ props.item.id}}</td>
              <td>{{ props.item.nome}}</td>
              <td>{{ props.item.cnpj ? props.item.cnpj : 'Não cadastrado' }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.telefone ? props.item.telefone : '-/-' }}</td>
              <td>{{ padronizaData(props.item.created_at) }}</td>
              <td class="text-xs-right botoes">

                <!-- <span v-if="!(props.item.deleted_at)">
                  <button class="btn_1 red delete wishlist_close mt-1 mb-1 button-content" @click="desativauser(props.item)">
                    <i class="fa fa-times"></i> Desativar
                  </button>
                </span>
                <span v-else>
                  <button class="btn_1 blue delete wishlist_close mb-1 mt-1 mb-1 button-content" @click="ativauser(props.item)">
                    <i class="fa fa-check"></i> Ativar
                  </button>
                </span> -->


                <router-link
                  class="btn_1 grey delete wishlist_close mb-1 button-content"
                  :to="'empresas/'+props.item.id"
                >
                  <i class="fa fa-eye"></i> Detalhes
                </router-link>


                
                
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "nome" },
        { text: "CNPJ", value: "cnpj"},
        { text: "E-Mail", value: "email"},
        { text: "Telefone", value: "telefone"},
        { text: "Data de criação", value: "created_at" },
        { text: "", value: "" }
      ],
      empresas: [],
      isLoading: false
    };
  },
  mounted() {
     var self = this;

     self.isLoading = true;
     ajax("get", "/empresas")
       .then(response => {

         self.isLoading = false;
         this.empresas = response;
         console.log('emepre',response)

/*          for(let usuario of self.usuarios) {
           
          usuario.subscriber 
           ? usuario.cpf = (usuario.subscriber.cpf ).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4")
           : usuario.cpf = '';
           
           usuario.phones.length > 0 
           ? usuario.telefone = `(${usuario.phones[0].area_code}) ${usuario.phones[0].number}` 
           : usuario.telefone = ''

           usuario.nome_completo = `${usuario.name} ${usuario.last_name}`

         } */

       })
       .catch(error => {
         self.isLoading = false;
         tratamento_requisicao(error, this);
       });
   
  },
  methods: {
    desativauser(user){
           let self = this;
           self.isLoading = true;
         ajax("delete", "usuarios/" + user.id)
           .then(response => {
             let indexItemRemovido = self.usuarios.findIndex(
               x => x.id == user.id
             );
             self.usuarios[indexItemRemovido].deleted_at = 1;
             self.isLoading = false;
             alerta(
               "success",
               "Desativado",
               "Usuário desativado com sucesso!"
             );
           })
           .catch(error => {
             self.isLoading = false;
             tratamento_requisicao(error, this);
           });
      },
  }
};
</script>
<style>
    .button-content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
    }
    @media (min-width: 1650px) {
      .botoes{
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-end;
      }
    }
</style>